'use client';

import * as React from 'react';
import OverlayPurchaseTicketsOverlayConfirmClient from '@/components/purchase-tickets-overlay/overlay-purchase-tickets-confirm-client';
import OverlayPurchaseFailureClient from '@/components/purchase-tickets-overlay/overlay-purchase-failure-client';
import OverlayPurchaseSuccessClient from '@/components/purchase-tickets-overlay/overlay-purchase-success-client';
import { useOverlay } from '@/components/hooks/useOverlay';
import { FrontTicketPurchaseOfferResponseDto } from '@/lib/jp-api/requests';
import { CmsParams } from '@/lib/cms-params.type';
import OverlayPurchaseTicketsClient, { ExchangeRateMap } from '@/components/purchase-tickets-overlay/overlay-purchase-tickets-client';
import { PurchaseTicket } from '@/components/jackpot/jackpot-purchase-tickets/jackpot-purchase-tickets-client';

export type OverlayPurchaseTicketsMeta = {
  ns: string;
  cmsParams: CmsParams;
  offer: FrontTicketPurchaseOfferResponseDto;
  numberOfTickets: number;
  baseOffer: FrontTicketPurchaseOfferResponseDto;
  offers: Array<FrontTicketPurchaseOfferResponseDto>;
  ticketsInPool: number;
  ticket: PurchaseTicket;
};

export type OverlayPurchaseTicketsConfirmMeta = {
  ns: string;
  ticket: PurchaseTicket;
  exchangeRates: ExchangeRateMap;
  cmsParams: CmsParams;
  offer: FrontTicketPurchaseOfferResponseDto;
  baseOffer: FrontTicketPurchaseOfferResponseDto;
  ticketAmount: number;
  total: string;
};

export type OverlayPurchaseTicketsSuccessMeta = {
  ns: string;
  ticket: PurchaseTicket;
  ticketAmount: number;
};

export type OverlayPurchaseTicketsFailureMeta = {
  ns: string;
  failureMessage: string;
};

export const Overlays: React.FC = () => {
  const { isOverlayOpen: isPurchaseTicketsOverlayOpen } = useOverlay<OverlayPurchaseTicketsMeta>(`purchase-tickets`);
  const { isOverlayOpen: isPurchaseTicketsConfirmOverlayOpen } = useOverlay<OverlayPurchaseTicketsConfirmMeta>(`purchase-confirm`);
  const { isOverlayOpen: isPurchaseTicketsSuccessOverlayOpen } = useOverlay<OverlayPurchaseTicketsSuccessMeta>(`purchase-success`);
  const { isOverlayOpen: isPurchaseTicketsFailureOverlayOpen } = useOverlay<OverlayPurchaseTicketsFailureMeta>(`purchase-failure`);

  return (
    <React.Fragment>
      {isPurchaseTicketsOverlayOpen && <OverlayPurchaseTicketsClient />}
      {isPurchaseTicketsConfirmOverlayOpen && <OverlayPurchaseTicketsOverlayConfirmClient />}
      {isPurchaseTicketsSuccessOverlayOpen && <OverlayPurchaseSuccessClient />}
      {isPurchaseTicketsFailureOverlayOpen && <OverlayPurchaseFailureClient />}
    </React.Fragment>
  );
};
